import { FC, ReactNode } from 'react';
import { MdDownload } from 'react-icons/md';
import { Menu, Button } from '@inexture/core';

const AdminHeading: FC<{
  title?: string | ReactNode;
  downloadIcon?: boolean;
  onDownload?: (format: string) => void;
}> = ({ title = 'Dashboard', downloadIcon = false, onDownload }) => {
  const formats = ['csv', 'xlsx', 'docx'];

  return (
    <div className="bg-white shadow drop-shadow-sm px-5 py-3">
      <div className="flex justify-between items-center">
        <h3 className="font-bold capitalize">{title}</h3>
        {downloadIcon && (
          <Menu shadow="md" width={120} position="bottom-end">
            <Menu.Target>
              <Button
                variant="filled"
                color="gray"
                leftSection={<MdDownload size={18} />}
              >
                Download
              </Button>
            </Menu.Target>

            <Menu.Dropdown className="overflow-y-auto">
              {formats.map(format => (
                <Menu.Item key={format} onClick={() => onDownload?.(format)}>
                  <p className="uppercase text-sm  ">{format}</p>
                </Menu.Item>
              ))}
            </Menu.Dropdown>
          </Menu>
        )}
      </div>
    </div>
  );
};

export default AdminHeading;
